import {ApplicationState} from "../reducers";
import {ThunkAction} from "redux-thunk";
import {apiDelete, apiError, apiPost, apiPut, apiRequest, CommonAction} from "./common";
import {Ticket} from "../models/hotels";
import {TicketPriceDelta} from "../models/order";

export const TICKETS_LOADING = "TICKETS_LOADING";
export const TICKETS_LOADED = "TICKETS_LOADED";
export const TICKETS_API_ERROR = "TICKETS_API_ERROR";
export const TICKETS_UPDATE_NEW = "TICKETS_UPDATE_NEW";
export const TICKETS_SAVE_LOADING = "TICKETS_SAVE_LOADING";
export const TICKETS_SAVED = "TICKETS_SAVED";
export const TICKETS_UPDATED = "TICKETS_UPDATED";
export const TICKETS_DELETED = "TICKETS_DELETED";
export const TICKETS_SHOW_INACTIVE = "TICKETS_SHOW_INACTIVE";

export const DELTA_UPDATE_NEW = "DELTA_UPDATE_NEW";
export const DELTA_LOADED = "DELTA_LOADED";
export const DELTA_SAVED = "DELTA_SAVED";
export const DELTA_UPDATED = "DELTA_UPDATED";
export const DELTA_DELETED = "DELTA_DELETED";

type TicketActionResponse = ThunkAction<Promise<TicketAction>, ApplicationState, {}>;

export interface TicketAction extends CommonAction {
    loading?: boolean;
    tickets?: Ticket[];
    newTicket?: Ticket;
    showInactive?: boolean;
    deltas?: TicketPriceDelta[];
    newDelta?: TicketPriceDelta;
}

export const getTicketList = (): TicketActionResponse => dispatch => {
    dispatch({type: TICKETS_LOADING});
    return apiRequest<Ticket[]>(`/tickets/all`)
        .then(response => {
            return dispatch({
                type: TICKETS_LOADED,
                tickets: response
            }) as TicketAction;
        })
        .catch(err => dispatch(apiError(TICKETS_API_ERROR, err)));
};

export const updateNewTicket = (ticket: Ticket): TicketAction => ({
    type: TICKETS_UPDATE_NEW, newTicket: ticket
} as TicketAction);

export const saveNewTicket = (ticket: Ticket): TicketActionResponse => dispatch => {
    dispatch({type: TICKETS_SAVE_LOADING});
    return apiPost<Ticket>(`/tickets`, ticket)
        .then(response => {
            return dispatch({
                type: TICKETS_SAVED,
                newTicket: response
            }) as TicketAction;
        })
        .catch(err => dispatch(apiError(TICKETS_API_ERROR, err)));
};

export const updateTicket = (ticket: Ticket): TicketActionResponse => dispatch => {
    dispatch({type: TICKETS_SAVE_LOADING});
    return apiPut<Ticket>(`/tickets/${ticket.id}`, ticket)
        .then(response => {
            return dispatch({
                type: TICKETS_UPDATED,
                newTicket: response
            }) as TicketAction;
        })
        .catch(err => dispatch(apiError(TICKETS_API_ERROR, err)));
};

export const deleteTicket = (ticket: Ticket): TicketActionResponse => dispatch => {
    dispatch({type: TICKETS_SAVE_LOADING});
    return apiDelete<Ticket>(`/tickets/${ticket.id}`)
        .then(response => {
            return dispatch({
                type: TICKETS_DELETED,
                newDiscount: ticket
            }) as TicketAction;
        })
        .catch(err => dispatch(apiError(TICKETS_API_ERROR, err)));
};

export const setShowInactive = (show: boolean): TicketAction => ({
    type: TICKETS_SHOW_INACTIVE, showInactive: show
} as TicketAction);

////// DELTAS

export const getDeltaList = (): TicketActionResponse => dispatch => {
    dispatch({type: TICKETS_LOADING});
    return apiRequest<TicketPriceDelta[]>(`/tickets/deltas`)
        .then(response => {
            return dispatch({
                type: DELTA_LOADED,
                deltas: response
            }) as TicketAction;
        })
        .catch(err => dispatch(apiError(TICKETS_API_ERROR, err)));
};

export const updateNewDelta = (delta: TicketPriceDelta): TicketAction => ({
    type: DELTA_UPDATE_NEW, newDelta: delta
} as TicketAction);

export const saveNewDelta = (delta: TicketPriceDelta): TicketActionResponse => dispatch => {
    dispatch({type: TICKETS_SAVE_LOADING});
    return apiPost<TicketPriceDelta>(`/tickets/deltas`, delta)
        .then(response => {
            return dispatch({
                type: DELTA_SAVED,
                newDelta: response
            }) as TicketAction;
        })
        .catch(err => dispatch(apiError(TICKETS_API_ERROR, err)));
};

export const updateDelta = (delta: TicketPriceDelta): TicketActionResponse => dispatch => {
    dispatch({type: TICKETS_SAVE_LOADING});
    return apiPut<TicketPriceDelta>(`/tickets/deltas/${delta.id}`, delta)
        .then(response => {
            return dispatch({
                type: DELTA_UPDATED,
                newDelta: response
            }) as TicketAction;
        })
        .catch(err => dispatch(apiError(TICKETS_API_ERROR, err)));
};

export const deleteDelta = (delta: TicketPriceDelta): TicketActionResponse => dispatch => {
    dispatch({type: TICKETS_SAVE_LOADING});
    return apiDelete<TicketPriceDelta>(`/tickets/deltas/${delta.id}`)
        .then(() => {
            return dispatch({
                type: DELTA_DELETED,
                newDelta: delta
            }) as TicketAction;
        })
        .catch(err => dispatch(apiError(TICKETS_API_ERROR, err)));
};



// WEBPACK FOOTER //
// ./src/actions/tickets.ts